// Central RBAC helpers. Keep in sync with backend/auth.py.
//
// Role hierarchy: student < staff < admin < superadmin.
//
// * `isAdmin(role)`       — admin OR superadmin. Use for the vast majority
//                            of "admin-tier" UI gates (create/edit
//                            payments, invoices, pricing, expenses…).
// * `isSuperAdmin(role)`  — superadmin only. Use for destructive or
//                            company-wide actions (edit Company &
//                            Banking, run backups, change any user's
//                            role, invite an admin, database tab…).
// * `isStaffOrAbove(role)`— staff / admin / superadmin. Use where we
//                            want to include staff (Team Members list,
//                            Analytics dashboards without revenue…).
// * `canEditFinancials(role)` — admin OR superadmin (alias for `isAdmin`).
//                            Named for clarity where the UI concept is
//                            "who can create/edit invoices, refunds,
//                            expenses" not "who is an admin generically".
//
// Roles are always compared to strings; unknown roles fall through to
// the safest answer (false).

export const ROLES = ["student", "staff", "admin", "superadmin"];

export const isSuperAdmin = (role) => role === "superadmin";
export const isAdmin = (role) => role === "admin" || role === "superadmin";
export const isStaffOrAbove = (role) => role === "staff" || role === "admin" || role === "superadmin";
export const canEditFinancials = (role) => isAdmin(role);
export const hasRetrofitAccess = (user) =>
  user?.role === "superadmin" || ((user?.role === "admin" || user?.role === "staff") && user?.retrofit_access === true);

/** Roles the current user is allowed to *assign* to another member. */
export function assignableRoles(actorRole) {
  if (actorRole === "superadmin") return ["student", "staff", "admin", "superadmin"];
  if (actorRole === "admin") return ["student", "staff"]; // admins cannot touch the admin tier
  return [];
}

export const ROLE_BADGE_STYLES = {
  superadmin: "bg-purple-100 text-purple-700 border-purple-200",
  admin: "bg-sky-100 text-sky-700 border-sky-200",
  staff: "bg-emerald-100 text-emerald-700 border-emerald-200",
  student: "bg-amber-100 text-amber-700 border-amber-200",
};
